module.exports = __webpack_public_path__ + "static/assets/b25ab003420dc568193a80578004c8fd.png";